(function(){
    (function ($) {

          $("#vid-modal1").on("show.bs.modal", function () {
        $("#js-video")[0].play();
      });
      $("#vid-modal1").on("hide.bs.modal", function () {
        $("#js-video")[0].pause();
      });

      $('#loginModal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget) 
        const actual_btn = button.closest('.product-card').find('button');
        let url = actual_btn.data('img') 
        let modal = $(this)
        modal.find('.login-banner').attr('src', url)
      })

      function updateCartBubbleFromServer() {
        $.getJSON('/cart.js').done(function(cart){
            updateCartBubble(cart.item_count || 0);
        }).fail(function(){
            console.warn('Unable to fetch cart.js to update badge.');
        });
      }

      function updateCartBubble(count) {
          const $icon = $('#cart-icon-bubble');

          if (!$icon.length) return;

          let $bubble = $icon.find('.cart-count-bubble');

          if (!$bubble.length) {
              $bubble = $(`
              <div class="cart-count-bubble">
                  <span aria-hidden="true"></span>
                  <span class="visually-hidden"></span>
              </div>
              `);
              $icon.append($bubble);
          }

          $bubble.find('span[aria-hidden="true"]').text(count);
          $bubble.find('.visually-hidden').text(count + (count === 1 ? " item" : " items"));

          if (count > 0) {
              $bubble.show();
              $bubble.addClass('cart-bubble-update');
              setTimeout(() => $bubble.removeClass('cart-bubble-update'), 600);
          } else {
              $bubble.hide();
          }
      }

       function addToCart() {
        $('#quantity').on('input', function(){
            this.value = this.value.replace(/[^0-9]/g, '');
            if (this.value === '' || this.value === '0') this.value = '1';
        });

         // Plus
        $('.qty-btn.plus').on('click', function(){
            let $qty = $('#quantity');
            let val = parseInt($qty.val()) || 1;
            $qty.val(val + 1).change();
        });

        // Minus
        $('.qty-btn.minus').on('click', function(){
            let $qty = $('#quantity');
            let val = parseInt($qty.val()) || 1;
            if(val > 1) $qty.val(val - 1).change();
        });

        $(document).on('click', '.direct-checkout-btn', function () {
            let $btn = $(this);

            $btn.prop('disabled', true);
            $btn.addClass('loading'); 
            $btn.data('original-text', $btn.text());
            $btn.text('Adding...');

            let qty = parseInt($('#quantity').val()) || 1;
            let variantId = $btn.attr('data-variant-id');

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: { id: variantId, quantity: qty },
                dataType: 'json',
                success: function(item) {
                    showCartNotification(item); 
                    updateCartBubbleFromServer(); 
                },
                error: function() {
                    alert("Something went wrong. Please try again.");
                },
                complete: function() {
                    $btn.prop('disabled', false);
                    $btn.removeClass('loading');
                    $btn.text($btn.data('original-text'));
                }
            });
        });
        }
        addToCart();


          function buildNotificationHtml(item){
            let imgUrl = item.image ? item.image.replace(/(\.jpg|\.png|\.gif)(?:\?.*)?$/i, '_compact$1') : '';
            let html = '<div class="cart-notification-item" style="display:flex;align-items:center;">';
            if(imgUrl){
            html += '<div style="width:64px;height:64px;margin-right:12px;"><img src="'+imgUrl+'" alt="'+escapeHtml(item.title)+'" style="width:100%;height:100%;object-fit:cover;border-radius:4px;"></div>';
            }
            html += '<div style="flex:1">';
            html += '<div style="font-weight:600;">' + escapeHtml(item.title) + '</div>';
            if(item.variant_title) html += '<div style="font-size:13px;color:#666;margin-top:3px;">' + escapeHtml(item.variant_title) + '</div>';
            html += '<div style="font-size:13px;color:#000;margin-top:6px;" class="quantity-text">Quantity: <span>' + (item.quantity||1) + '</span></div>';
            html += '</div>';
            html += '</div>';
            return html;
        }

        function escapeHtml(text){
            return (text || '').replace(/[&<>"'`]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','`':'&#96;'}[ch]; });
        }

        function showCartNotification(item){
            $.getJSON('/cart.js').done(function(cart){
            updateCartCountUI(cart.item_count || 0);
            let html = buildNotificationHtml(item);
            $('#cart-notification-product').html(html);


            let $notif = $('#cart-notification');
            if(!$notif.length) return;

            if($notif.hasClass('is-hidden') || $notif.hasClass('hidden')) {
                $notif.removeClass('is-hidden hidden');
            }

            $notif.css({
                'transform': 'translateY(0)',
                'visibility': 'visible',
                'transition': 'transform 300ms ease, visibility 300ms'
            });

            $notif.attr('aria-hidden', 'false');
            $notif.focus();

            }).fail(function(){
            $('#cart-notification-product').html(buildNotificationHtml(item));
            let $notif = $('#cart-notification');
            $notif.css({ 'transform': 'translateY(0)', 'visibility': 'visible', 'transition': 'transform 300ms ease' });
            $notif.attr('aria-hidden','false').focus();
            });
        }

        function updateCartCountUI(count){
            let selectors = ['.cart-count', '.site-header__cart-count', '[data-cart-count]', '.js-cart-count', '.cart-badge', '.header-cart-count'];
            selectors.forEach(function(sel){
            $(sel).each(function(){ $(this).text(count); });
            });
            $('[data-cart-count]').attr('data-cart-count', count);
            try{ $(document).trigger('cart:updated', { item_count: count }); }catch(e){}
        }

        $(document).on('click', '#cart-notification .cart-notification__close, #cart-notification .button-label', function(e){
            e.preventDefault();
            hideCartNotification();
        });

        function hideCartNotification(){
            let $notif = $('#cart-notification');
            if(!$notif.length) return;
            $notif.css({ 'transform': 'translateY(-100%)', 'visibility': 'hidden' });
            $notif.attr('aria-hidden','true');
        }



        
        document.addEventListener("DOMContentLoaded", function () {

          const modal = document.querySelector("#MainContent .icartShopifyCartContent > section.shopify-section");
          const openButtons = document.querySelectorAll(".open-modal");
          function openModal() {
            // Add class to ALL open buttons
            openButtons.forEach(btn => btn.classList.add("modal-opened"));

                $('#loginAuthModal').modal('hide');
            // Show modal
            modal.classList.add("show");

            // Create backdrop
            const backdrop = document.createElement("div");
            backdrop.className = "custom-modal-backdrop";
            modal.appendChild(backdrop);

            // Close when clicking backdrop
            backdrop.addEventListener("click", () => closeModal(backdrop));
          }

          function closeModal(backdrop) {
            modal.classList.remove("show");

            openButtons.forEach(btn => btn.classList.remove("modal-opened"));

            backdrop.remove();
          }

          // Attach open click to all buttons
          openButtons.forEach(btn => {
            btn.addEventListener("click", openModal);
          });

        });


        document.addEventListener("DOMContentLoaded", function () {
          const params = new URLSearchParams(window.location.search);
          const submitStatus = params.get("email_submit");

          if (submitStatus === "success") {
            localStorage.setItem("natpat_email_submit", "success");
          }
          const stored = localStorage.getItem("natpat_email_submit");

          if (stored === "success") {
            document.body.classList.add("natpat_email_submit");
          } else {
            document.body.classList.remove("natpat_email_submit");
          }
        });

      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".tab-panel").forEach(function (panel) {
          const grid = panel.querySelector(".products-grid");

          if (!grid || grid.children.length === 0) {
            panel.style.display = "none";

            const panelName = panel.getAttribute("data-panel");
            const tabButton = document.querySelector(`[data-tab="${panelName}"]`);

            if (tabButton) {
              tabButton.style.display = "none";
            }
          }
        });
      });

     const observer = new MutationObserver((mutations, obs) => {
        const container = document.querySelector('#MainContent .icartShopifyCartContent > section.shopify-section .page-width');
        const link = document.querySelector('.email-sign-in').href;
        console.log(link);
        if (container) {
          const loginLink = document.createElement('button');
          // loginLink.href = '/account/login';
          loginLink.className = 'open-login';
          loginLink.innerHTML = `Already a member? <a href="${link}" class="button-label">Log in</a> <br> Enter the email you ordered with and we'll send you a magic link to sign in instantly.`;
          // loginLink.innerText = 'Already a customer? Log in';

          // loginLink.addEventListener('click', function () {
          //    $('#loginAuthModal').modal('show');
          //    const modal = $("#MainContent .icartShopifyCartContent > section.shopify-section");
          //    modal.removeClass("show");
          //    const backdrop = $(".custom-modal-backdrop");
          //    if (backdrop.length) backdrop.remove();
          // });
          
          container.appendChild(loginLink);
          
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      

    })(jQuery);
   
    // document.querySelectorAll('.product-unlock-btn').forEach(btn => {
    //   const url = btn.dataset.img;

    //   // Preload image once
    //   const preImg = new Image();
    //   preImg.src = url;

    //   btn.addEventListener('click', function () {
    //     document.querySelector('.login-banner').src = url;
    //   });
    // });

  document.querySelectorAll('.tabbed-products').forEach(function(root){
    var buttons = root.querySelectorAll('.tab-button');
    var panels = root.querySelectorAll('.tab-panel');

    function activateTab(tabKey) {
      buttons.forEach(function(btn){
        var key = btn.getAttribute('data-tab');
        var isActive = (key === tabKey);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) btn.parentElement.classList.add('active'); else btn.parentElement.classList.remove('active');
      });

      panels.forEach(function(panel){
        if (panel.getAttribute('data-panel') === tabKey) panel.classList.add('active'); else panel.classList.remove('active');
      });
    }

    buttons.forEach(function(button){
      button.addEventListener('click', function(){
        activateTab(this.getAttribute('data-tab'));
      });
      button.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(this.getAttribute('data-tab'));
        }
      });
    });

    // initial: show All
    activateTab('all');
  });

})();

